<template>
  <div class="yx-statistics-jxf-page main-layout">
    <!-- <BackToPrePage /> -->
    <CCollapseItem>
      <template slot="title-left">
        <i
          class="iconfont icon-fanhui"
          @click.stop="$router.go(-1)"
          style="font-size: 20px; margin-right: 10px"
        ></i>
        <span>绿色通道统计</span>
      </template>
      <template slot="body">
        <c-search
          v-model="pageParams"
          :searchItems="searchItems"
          @reset="refresh"
          @search="pageGet(true)"
        >
        </c-search>
      </template>
    </CCollapseItem>
    <el-card class="box-table box-bottom">
      <div slot="header" class="btn-group">
        <!-- 操作按钮 -->
        <div class="btn-left">
          <div class="opt-btn" title="导出" @click="exportExcel">
            <i
              class="iconfont icon-daochu3"
              :class="{ disabled: isExport }"
            ></i>
          </div>
        </div>
        <!-- 右侧操作按钮 -->
        <table-btns
          :tableColumns="tableColumns"
          @tableColumnsChange="tableColumnsChange"
          @refresh="
            idList = [];
            pageGet(true);
          "
        ></table-btns>
      </div>

      <c-table
        :data="pageData"
        :tableColumns="tableColumns"
        :pagination="pageParams"
        @change="pageGet"
        @selectionChange="selectionChange"
        v-loading="pageLoading"
      >
        <template slot="status" slot-scope="scope">
          <span>{{
            scope.row.isOrNot == null
              ? "-"
              : scope.row.isOrNot == 0
              ? "否"
              : "是"
          }}</span>
        </template>
        <template slot="custom" slot-scope="scope">
          <div class="contr-btn-group">
            <div
              v-if="scope.row.isOrNot == 1"
              class="contr-btn"
              title="详情"
              @click="handeShowDetail(scope.row.id)"
            >
              <img src="../../../../../assets/images/icon/detail.png" />
            </div>
            <div
              v-else
              class="contr-btn"
              title="详情"
              style="cursor: not-allowed"
            >
              <img src="../../../../../assets/images/icon/detail.png" />
            </div>
          </div>
        </template>
      </c-table>
    </el-card>
    <!-- 详情弹框 -->
    <el-dialog
      :close-on-click-modal="false"
      title="详情"
      :visible.sync="dialogVisible"
      width="60%"
    >
      <div class="pre-detail-container">
        <div class="div-scroll">
          <green-detail :detailInfo="detailInfo"></green-detail>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MPage from "@/mixins/MPage.js";
import Configs from "./data/green";
import greenDetail from "./greenDetail";
import { getOrgOptions } from "@/libs/searchSelect.js";
import { mapState } from "vuex";
let mPage = MPage({
  pagePath: "/welcome-forecast/statistics/oneForecastLinkListPage",
  pageDelPath: "",
  pageDelsPath: "",
  pageParams: {
    collegeId: "",
    grade: "",
    majorId: "",
    classId: "",
    classIdList: [],
    academicDegree: "",
    academicYear: "",
    studentNoOrName: "",
    sex: "",
    linkId: "",
    isOrNot: null,
  },
  pageExportPath: "/welcome-forecast/statistics/exportExcel/oneForecast",
  pageExportParams: {},
});
export default {
  mixins: [mPage],
  name: "",
  components: { greenDetail },
  data() {
    let { searchItems, tableColumns } = Configs(this);
    return {
      isFold: false,
      searchItems,
      tableColumns,
      idList: [],
      linkId: "",
      dialogVisible: false, // 详情弹框
      detailInfo: {},
      isExport: false, // 是否导出
      message: null,
    };
  },
  computed: {
    ...mapState("dic", [
      "SUCCESS_CODE",
      "_CURRENTYEAR",
      "_COLLEGE_ID",
      "_CURRENT_ACADEMIC",
    ]),
  },
  created() {
    this.setCollegeId();
    this.linkId = this.$route.params.linkId;
    this.pageParams.linkId = this.linkId;
  },
  mounted() {},
  methods: {
    setCollegeId() {
      if (this._COLLEGE_ID) {
        this.pageParams.collegeId = this._COLLEGE_ID;
        getOrgOptions(
          this,
          { parentId: this._COLLEGE_ID, type: "department" },
          1,
          null
        );
      }
    },
    selectionChange(data) {
      let idList = [];
      if (data.length) {
        data.forEach((item) => {
          idList.push(item.studentId);
        });
        this.idList = idList;
      }
    },
    handleDelBatch() {
      if (this.idList.length) {
        this.pageDels(this.idList);
      } else {
        this.$message({
          message: "请选择需要删除的数据！",
          type: "warning",
        });
      }
    },
    pageDelAfterFn() {
      this.idList = [];
      this.pageGet(true);
    },
    pageGetBeforeFn(data) {
      let params = Object.assign({}, data);
      if (!params.academicDegree)
        params.academicDegree = this._CURRENT_ACADEMIC;
      params.enrollmentYear = this._CURRENTYEAR[0].value;
      params.classId = params.classIdList.join(",");
      delete params.classIdList;
      return params;
    },
    refresh() {
      this.idList = [];
      this.searchItems[2].options = [];
      this.searchItems[3].options = [];
      this.pageParams = {
        collegeId: "",
        grade: "",
        majorId: "",
        classId: "",
        classIdList: [],
        academicDegree: "",
        academicYear: "",
        studentNoOrName: "",
        sex: "",
        linkId: this.linkId,
        isOrNot: null,
      };
      this.setCollegeId();
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    exportExcel() {
      if (this.isExport) {
        return;
      } else {
        this.isExport = true;
        this.message = this.$message({
          message: "数据正在导出中，请稍候！",
          duration: 0,
          type: "warning",
          center: true,
        });
        let params = Object.assign({}, this.pageParams);
        if (!params.academicDegree)
          params.academicDegree = this._CURRENT_ACADEMIC;
        params.enrollmentYear = this._CURRENTYEAR[0].value;
        this.pageExportParams = params;
        if (this.idList.length) {
          this.pageExportParams.studentIdStr = this.idList.join();
        }
        this.pageExportParams.classId = this.pageExportParams.classIdList.join(
          ","
        );
        delete this.pageExportParams.classIdList;
        this.pageExport();
      }
    },
    pageExportAfterFn() {
      this.isExport = false;
      this.message.close();
      this.message = null;
      this.refresh();
      this.pageExportParams = {};
    },
    // 显示详情
    handeShowDetail(id) {
      this.getDetailInfo(id);
      this.dialogVisible = true;
    },
    getDetailInfo(id) {
      this.$http
        .get("/welcome-forecast/green/apply/" + id)
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.detailInfo = res.data;
          } else {
            this.detailInfo = {};
          }
        })
        .catch((err) => {
          this.detailInfo = {};
        });
    },
  },
};
</script>
